<template>
  <div id="orderconfirm">
    <h2 class="title">
      <a @click="back" class="prev"></a>
      订单详情
    </h2>
    <!--地址栏-->
    <a href="javascript:" v-if="shopData.book_id">
      <div class="address">
        <p class="selected" v-if="addressData.add_id" @click="gotoAdd">
          <b>{{addressData.name}}</b><i>{{addressData.phone}}</i><br>
          {{addressData.province}}{{addressData.city}}{{addressData.county}}{{addressData.address}}
        </p>
        <p class="selected" v-else @click="gotoAdd">
          <b class="where">您需要我们送到哪里？</b>
        </p>
        <span class="arrow"></span>
      </div>
    </a>
    <!--订单价格明细-->
    <div class="detail">
      <div class="left">
        <img :src="shopData.app_img_1" alt="">
      </div>
      <div class="middle">
        <h3>
          {{shopData.name}}
        </h3>
      </div>
      <div class="right">
        ¥<b>{{shopData.price}}</b>{{shopData.price_decimal}}
      </div>
    </div>
    <!--优惠券-->
    <div class="coupon" @click="showCoupon">
      <b>优惠券</b>
      <a>
        {{couponData.name ? couponData.name : '无可用'}}
        <span class="dot">
          <i></i>
          <i></i>
          <i></i>
        </span>
      </a>
    </div>

    <!--微信-->
    <div class="wxpay" v-if="paymentData[0]">
      <label>
        <b>微信支付</b>
        <input type="radio" name="paytype"  :value="paymentData[0].pay_id" v-model="payType" checked>
        <span></span>
      </label>
    </div>
    <!--支付宝-->
    <div class="alipay" v-if="paymentData[1]">
      <label>
        <b>支付宝支付</b>
        <input type="radio" name="paytype" :value="paymentData[1].pay_id" v-model="payType">
        <span></span>
      </label>
    </div>
    <order-coupon v-if="couponShow" :shopId="this.$route.query.shop_id" :shopType="this.$route.query.shop_type" :isSingle="this.$route.query.single_id" v-on:listenShow="hideCoupon()" @listenChoose="selectedCoupon"></order-coupon>
    <div class="bg"></div>
    <div class="fix-bar">
      <b>¥<span>{{couponData.money ? parseInt(shopData.price - couponData.money) : shopData.price}}</span>{{shopData.price_decimal}}</b>
      <div class="discount" v-show="couponData.money">已优惠：¥{{couponData.money}}元</div>
      <a @click="gotoPay" class="payfor">马上结算</a>
    </div>
  </div>
</template>

<script>
import OrderCoupon from './OrderCoupon'
export default {
  name: 'OrderConfirm',
  components: {
    OrderCoupon
  },
  data () {
    return {
      shopId: this.$route.query.shop_id, // 商品ID
      shopType: this.$route.query.shop_type, // 商品分类 商品分类 0 课程 1 教材 2会员 其他待定
      infoId: this.$route.query.info_id, // 0 全科 1 单科
      singleId: this.$route.query.single_id,
      addressData: {},
      paymentData: {},
      shopData: {},
      couponData: {},
      payType: 1,
      couponId: 0,
      addressId: 0,
      emsType: 'YTO',
      couponShow: false,
      isWeixin: false, // 是否微信浏览器打开  1 是  0 不是
      shopNumber: 0 // 商品订单号
    }
  },
  methods: {
    // 获得信息
    getAddress () {
      let data = {
      }
      this.$axios({
        method: 'GET',
        url: '/api/app/v1/get_order_receiving_address',
        params: data,
        headers: {
          'sign': this.$encryption(data, this.$store.state.token, this.$store.state.uid)
        }
      })
        .then(res => {
          if (res.data.errcode === 200) {
            this.addressData = res.data.data
          } else console.log(res.data.message)
        })
        .catch(err => {
          console.log(err)
        })
    },
    getPayment () {
      let data = {
      }
      this.$axios({
        method: 'GET',
        url: '/api/app/v1/get_order_payment_method',
        params: data,
        headers: {
          'sign': this.$encryption(data, this.$store.state.token, this.$store.state.uid)
        }
      })
        .then(res => {
          if (res.data.errcode === 200) {
            this.paymentData = res.data.data
          } else console.log(res.data.message)
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 获得订单信息：班级、图片、价格
    getShop () {
      let data = {
        shop_id: this.$route.query.shop_id,
        info_id: this.$route.query.info_id,
        single_id: this.$route.query.single_id,
        shop_type: this.$route.query.shop_type
      }
      this.$axios({
        method: 'POST',
        url: '/api/app/v1/post_order_form',
        params: data,
        headers: {
          'sign': this.$encryption(data, this.$store.state.token, this.$store.state.uid)
        }
      })
        .then(res => {
          console.log(res)
          if (res.data.errcode === 200) {
            this.shopData = res.data.data
            if (res.data.data.shop_number) {
              this.isWeixin = res.data.data.isWeixin
              this.shopNumber = res.data.data.shop_number
              // this.getOrderStatus()
              // this.checkOrderStatus() // 因微信使用返回上一步 暂时解决方案
            }
          } else console.log(res.data.message)
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 获得默认优惠券
    getCoupon () {
      let data = {
        shop_id: this.$route.query.shop_id,
        shop_type: this.$route.query.shop_type,
        is_single: this.$route.query.single_id,
        status: 0 // 使用状态 0 未使用  1 使用中  2 已使用  3 已过期
      }
      this.$axios({
        method: 'GET',
        url: '/api/app/v1/get_order_coupon',
        params: data,
        headers: {
          'sign': this.$encryption(data, this.$store.state.token, this.$store.state.uid)
        }
      })
        .then(res => {
          if (res.data.errcode === 200) {
            this.couponData = res.data.data
            if (res.data.data.vou_id) {
              this.couponId = res.data.data.vou_id
            }
          } else console.log(res.data.message)
        })
        .catch(err => {
          console.log(err)
        })
    },
    showCoupon () {
      this.couponShow = true
    },
    hideCoupon () {
      this.couponShow = false
    },
    gotoPay () {
      this.$router.push({
        name: 'OrderPaying',
        params: {
          add_id: this.shopData.book_id ? this.addressData.add_id : 0,
          shop_id: this.$route.query.shop_id,
          shop_type: this.$route.query.shop_type,
          single_id: this.$route.query.single_id,
          vou_id: this.couponId,
          payment_method: this.payType,
          shop_courier_money: 0,
          shop_courier_name: this.emsType,
          _sign: this.submitSign
        },
        query: {
          shop_number: this.shopNumber
        }
      })
      return false
      /*
      let data = {
        add_id: this.shopData.book_id ? this.addressData.add_id : 0,
        shop_id: this.$route.query.shop_id,
        shop_type: this.$route.query.shop_type,
        single_id: this.$route.query.single_id,
        vou_id: this.couponId,
        payment_method: this.payType,
        shop_courier_money: 0,
        shop_courier_name: this.emsType
      }
      this.$axios({
        method: 'POST',
        url: '/api/app/v1/post_order_immediate_payment',
        params: data,
        headers: {
          'sign': this.$encryption(data, this.$store.state.token, this.$store.state.uid)
        }
      })
        .then(res => {
          console.log(res)
          if (res.data.errcode === 200) {
            this.$router.push({name: 'PaySuccess'})
          } else console.log(res.data.message)
        })
        .catch(err => {
          console.log(err)
        })
    */
    },
    back () {
      if (window.history.length <= 1) {
        this.router.push({path: '/'})
      } else {
        this.$router.go(-1)
      }
    },
    gotoAdd () {
      this.$router.push({name: 'AddressList'})
    },
    selectedCoupon (obj) {
      this.couponData = obj
      this.couponId = obj.vou_id
      this.couponShow = false
    }
  },
  computed: {
    submitSign: function () {
      let data = {
        add_id: this.shopData.book_id ? this.addressData.add_id : 0,
        shop_id: this.$route.query.shop_id,
        shop_type: this.$route.query.shop_type,
        single_id: this.$route.query.single_id,
        vou_id: this.couponId,
        payment_method: this.payType,
        shop_courier_money: 0,
        shop_courier_name: this.emsType,
        shop_number: this.shopNumber
      }
      return this.$encryption(data, this.$store.state.token, this.$store.state.uid)
    }
  },
  mounted () {
    this.getAddress()
    this.getPayment()
    this.getShop()
    this.getCoupon()
  }
}
</script>

<style scoped lang="stylus">
#orderconfirm
  background-color: #F7F7F7
  .title
    position: relative
    line-height: .8rem
    background-color: #1E81F2
    padding: .14rem .16rem
    font-size: .4rem
    color: #fff
    font-weight: 600
    text-align: center
    a.prev
      position: absolute
      top: .14rem
      left: .16rem
      display: block
      width: .8rem
      height: .8rem
      background-color: transparent
      -webkit-border-radius: 50%
      -moz-border-radius: 50%
      border-radius: 50%
      &::before
        content: ""
        position: absolute
        top: .3rem
        left: .32rem
        display: block
        width: .20rem
        height: .20rem
        border-left: .03rem solid #fff
        border-bottom: .03rem solid #fff
        -webkit-transform: rotate(45deg)
        -moz-transform: rotate(45deg)
        -ms-transform: rotate(45deg)
        -o-transform: rotate(45deg)
        transform: rotate(45deg)
  .address
    display: flex
    justify-content: space-between
    align-items: center
    width: 7.5rem
    height: 2.24rem
    padding: 0 .4rem
    background-color: #fff
    -webkit-box-sizing: border-box
    -moz-box-sizing: border-box
    box-sizing: border-box
    p
      width: 6.14rem
      font-size: .26rem
      color: #333
      b.where
        font-size: .4rem
        color: #050505
        font-weight: 700
      &.selected
        padding-left: .76rem
        font-size: .26rem
        color: #333
        /*background: url(../../assets/icon/orderconfirm_icon_locate.png) no-repeat left .65rem*/
        background: url(../../assets/icon/orderconfirm_icon_locate.png) no-repeat left center
        -webkit-background-size: .56rem
        background-size: .56rem
        -webkit-box-sizing: border-box
        -moz-box-sizing: border-box
        box-sizing: border-box
        b
          display: inline-block
          margin: 0 .2rem .1rem 0
          font-size: .36rem
          color: #050505
        i
          font-size: .24rem
          color: #9DA4B3
          font-style: normal
    span.arrow
      position: relative
      top: .03rem
      right: .2rem
      display: block
      width: .20rem
      height: .20rem
      border-left: .03rem solid #050505
      border-bottom: .03rem solid #050505
      -webkit-transform: rotate(-135deg)
      -moz-transform: rotate(-135deg)
      -ms-transform: rotate(-135deg)
      -o-transform: rotate(-135deg)
      transform: rotate(-135deg)
  .detail
    display: flex
    justify-content: space-between
    width: 7.5rem
    background-color: #fff
    padding: .4rem
    margin-top: .2rem
    -webkit-box-sizing: border-box
    -moz-box-sizing: border-box
    box-sizing: border-box
    .left
      width: 1.64rem
      height: 1.64rem
      img
        width: 100%
        height: 100%
    .middle
      width: 3.62rem
      h3
        font-size: .26rem
        color: #161616
    .right
      width: 1.18rem
      font-size: .22rem
      b
        font-size: .35rem
  .coupon
    display: flex
    justify-content: space-between
    align-items: center
    height: .8rem
    line-height: .8rem
    background-color: #fff
    padding: 0 .4rem
    margin-top: .2rem
    -webkit-box-sizing: border-box
    -moz-box-sizing: border-box
    box-sizing: border-box
    b
      font-size: .24rem
      color: #333
      font-weight: 400
    a
      font-size: .24rem
      color: #333
      font-weight: 400
      span.dot
        position: relative
        top: -.04rem
        display: inline-flex
        justify-content: space-between
        align-items: center
        width: .3rem
        height: .09rem
        vertical-align: baseline
        margin: 0 .1rem
        i
          display: inline-block
          width: .09rem
          height: .09rem
          background-color: #999
          -webkit-border-radius: 50%
          -moz-border-radius: 50%
          border-radius: 50%
          &:nth-of-type(1), &:nth-of-type(3)
            display: inline-block
            width: .06rem
            height: .06rem
            background-color: #D8D8D8
            -webkit-border-radius: 50%
            -moz-border-radius: 50%
            border-radius: 50%
  .wxpay, .alipay
    width: 7.5rem
    height: .8rem
    background-color: #fff
    padding: 0 .4rem
    margin-top: .2rem
    -webkit-box-sizing: border-box
    -moz-box-sizing: border-box
    box-sizing: border-box
    label
      display: flex
      justify-content: space-between
      align-items: center
      height: 100%
      b
        font-size: .24rem
        color: #333
        &::before
          content: ""
          display: inline-block
          width: .4rem
          height: .4rem
          background: url(../../assets/icon/orderdetail_icon_weixin.png) no-repeat center
          -webkit-background-size: 100%
          background-size: 100%
          vertical-align: middle
          margin-right: .2rem
      input
        display: none
      span
        display: inline-block
        width: .4rem
        height: .4rem
        background: url(../../assets/icon/classall_icon_noselect.png) no-repeat center
        -webkit-background-size: 100%
        background-size: 100%
      input:checked + span
        background-image: url(../../assets/icon/classall_icon_tick.png)
  .alipay
    label
      b
        &::before
          background-image: url(../../assets/icon/orderdetail_icon_zhifubao.png)
  .bg
    position: fixed
    top: 0
    left: 0
    z-index: -1
    width: 100%
    height: 100%
    background-color: #F7F7F7
  .fix-bar
    position: fixed
    bottom: 0
    left: 0
    display: flex
    justify-content: space-between
    align-items: center
    width: 7.5rem
    height: .98rem
    background-color: #fff
    padding: 0 .2rem
    -webkit-box-sizing: border-box
    -moz-box-sizing: border-box
    box-sizing: border-box
    b
      display: block
      width: 2rem
      height: .98rem
      line-height: .98rem
      font-size: .28rem
      color: #FF7052
      font-weight: 400
      text-align: center
      span
        font-size: .36rem
        font-weight: 600
    .discount
      /*visibility: hidden*/
      width: 2.68rem
      height: .98rem
      line-height: .98rem
      margin-right: .2rem
      background-color: rgba(172,229,255,.12)
      font-size: .24rem
      color: #2BAAFF
      text-align: center
    a.payfor
      display: inline-block
      width: 2.4rem
      height: .72rem
      line-height: .72rem
      background-color: #FF7052
      /* background-color: rgba(255,112,82,0.7) */
      font-size: .32rem
      color: #fff
      text-align: center
      -webkit-border-radius: .49rem
      -moz-border-radius: .49rem
      border-radius: .49rem
</style>



// WEBPACK FOOTER //
// src/components/order/OrderConfirm.vue